module.exports = __webpack_public_path__ + "static/img/home_2.23bb5df7.svg";